import React, { useState } from 'react';
import { HeaderWrapper } from './styled';
import { Link, useNavigate } from 'react-router-dom';

const Header = (props) => {
	const [isHovered, setIsHovered] = useState(false);
	const nav = useNavigate();

	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	const [isOpen, setIsOpen] = useState(false);
	const [isOpen2, setIsOpen2] = useState(false);
	const [isToggled, setToggled] = useState(false);

	const toggleDropdown = () => {
		if (isToggled) {
			hamToggle();
		}
		setIsOpen(!isOpen);
	};

	const hamToggle = () => {
		setIsOpen2(!isOpen2);
		setToggled(!isToggled);
		if (isOpen) {
			setIsOpen(false);
		}
	};

	const [s, setS] = useState('');

	const DoSearch = () => {
		if (s) {
			setIsOpen((p) => !p);
			setIsOpen(false);
			nav(`/s/${s}`);
		}
	};

	const DoEnter = (e) => {
		if (e.key === 'Enter') {
			setIsOpen(false);
			DoSearch();
		}
	};

	return (
		<HeaderWrapper>
			<div className="wrapper">
				<div className="pc-header">
					<div className="flex">
						<div className="logo">
							<Link to="/">
								<img src="/images/logo.png" alt="" />
							</Link>
						</div>
						<div className="right-box">
							<ul className="gnb">
								<a href="https://www.kbds.co.kr" target="_blank">
									<li>KBDS 홈페이지</li>
								</a>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<li>Recruit</li>
								</a>
								<a
									href="https://www.youtube.com/channel/UCFsYPVbeWWdg6zM7mDHpUJQ"
									target="_blank"
								>
									<li>YouTube</li>
								</a>
							</ul>
							{/* <div className="icon-box">
								<div
									className={`arrow ${isHovered ? 'hovered' : ''}`}
									onMouseEnter={handleMouseEnter}
									onMouseLeave={handleMouseLeave}
								>
									<img
										className="arrow-img"
										src={
											isHovered
												? '/images/icon-hover-arrow.svg'
												: '/images/icon-header-arrow.svg'
										}
										alt=""
									/>
									<div className="arrow-text">
										<a
											href="https://kbds.career.greetinghr.com/"
											target="_blank"
										>
											Recruit
										</a>
										<a href="https://econ.kds.co.kr/welcome.so" target="_blank">
											Partner
										</a>
										<a href="https://www.kbds.co.kr/global" target="_blank">
											Global
										</a>
									</div>
								</div>
								<div className="search" onClick={toggleDropdown}>
									<img src="/images/icon-header-search.svg" alt="" />
								</div>
							</div> */}
							<div className="search" onClick={toggleDropdown}>
								<img src="/images/icon-header-search.svg" alt="" />
							</div>
						</div>
					</div>
					<div className={`toggle ${isOpen ? 'open' : ''}`}>
						<>
							<div className="dropdown">
								<div className="toggle-wrap">
									<div className="close-btn" onClick={toggleDropdown}>
										<img src="/images/icon-close01.svg" alt="" />
									</div>
									<div className="inner">
										<div className="input-box">
											<img src="/images/icon-search01.svg" alt="" />
											<input
												onChange={(e) => setS(e.target.value)}
												onKeyDown={DoEnter}
												type="text"
												placeholder="검색어를 입력하세요."
											/>
										</div>
										<div className="tag-box">
											<h3>최근 가장 인기있는 태그</h3>
											<ul className="tag">
												<li>#조직문화</li>
												<li>#조직문화</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</>
					</div>
				</div>
				<div>
					<div className="mo-header">
						<div className="logo">
							<Link to="/">
								<img src="/images/mo-logo.png" alt="" />
							</Link>
						</div>
						<div className="icon-box">
							<img
								src="/images/icon-mo-search.svg"
								alt=""
								onClick={toggleDropdown}
								className="search"
							/>
							<img
								src={
									isToggled
										? '/images/icon-mo-close.svg'
										: '/images/icon-mo-ham.svg'
								}
								alt=""
								onClick={hamToggle}
								className="ham"
								style={{
									backgroundColor: isToggled ? '#F7F7F7' : 'transparent',
									borderRadius: isToggled ? '4px' : '0',
								}}
							/>
						</div>
					</div>
					<div className={`toggle ${isOpen ? 'open' : ''}`}>
						<div className={`dropdown ${isOpen ? 'open' : ''}`}>
							<div className="toggle-wrap">
								<div className="close-btn">
									<img
										src="/images/icon-close01.svg"
										alt=""
										onClick={toggleDropdown}
									/>
								</div>
								<div className="inner">
									<div className="input-box">
										<img
											onClick={DoSearch}
											src="/images/icon-search01.svg"
											alt=""
										/>
										<input
											onChange={(e) => setS(e.target.value)}
											onKeyDown={DoEnter}
											type="text"
											placeholder="검색어를 입력하세요."
										/>
									</div>
									<div className="tag-box">
										<h3>최근 가장 인기있는 검색어</h3>
										<ul className="tag">
											<li>#KBDS</li>
											<li>#멘토</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={`ham-toggle ${isOpen2 ? 'open' : ''}`}>
						{isOpen2 && (
							<>
								<div className="dropdown">
									<div className="toggle-wrap">
										<a href="https://www.kbds.co.kr" target="_blank">
											<p>KBDS 홈페이지</p>
										</a>
										<a
											href="https://kbds.career.greetinghr.com/"
											target="_blank"
										>
											<p>Recruit</p>
										</a>
										<a
											href="https://www.youtube.com/channel/UCFsYPVbeWWdg6zM7mDHpUJQ"
											target="_blank"
										>
											<p>YouTube</p>
										</a>
										{/* <ul>
											<a
												href="https://kbds.career.greetinghr.com/"
												target="_blank"
											>
												<li>
													Recruit
													<img src="/images/icon-toparrow.svg" alt="" />
												</li>
											</a>
											<a
												target="_blank"
												href="https://econ.kds.co.kr/welcome.so"
											>
												<li>
													Partner
													<img src="/images/icon-toparrow.svg" alt="" />
												</li>
											</a>
											<a target="_blank" href="https://www.kbds.co.kr/global">
												<li>
													Global
													<img src="/images/icon-toparrow.svg" alt="" />
												</li>
											</a>
										</ul> */}
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			<div
				onClick={() => setIsOpen((p) => !p)}
				className={isOpen ? 'overlay active' : 'overlay'}
			></div>
			<div
				onClick={() => setIsOpen2((p) => !p)}
				className={isOpen2 ? 'overlay active' : 'overlay'}
			></div>
		</HeaderWrapper>
	);
};

export default Header;
